import { render } from "./SocialNetworksButtons.vue?vue&type=template&id=e2b05000&scoped=true&ts=true"
import script from "./SocialNetworksButtons.vue?vue&type=script&lang=ts"
export * from "./SocialNetworksButtons.vue?vue&type=script&lang=ts"

import "./SocialNetworksButtons.vue?vue&type=style&index=0&id=e2b05000&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b05000"]])

export default __exports__